import { AbstractControl, ValidationErrors } from '@angular/forms';

const UNSAFE_CONTENT = /[<>{}]/;
const BRACKETED_EMAIL = /<[A-Za-z0-9._+%-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}>/g;

export function commentCharactersValidator(control: AbstractControl): ValidationErrors | null {
  const value = control.value;

  if (typeof value !== 'string') {
    return null;
  }

  const replacedValue = value.replace(BRACKETED_EMAIL, '');

  if (UNSAFE_CONTENT.test(replacedValue)) {
    return {
      invalidCommentCharacters: true,
    };
  }
  return null;
}
